export const useResizeTimeout = (funcResize: () => void) => {
  let ticking: boolean | undefined
  let oldWidth = 0

  const handleResize = () => {
    if (!ticking) {
      if (oldWidth === window.innerWidth) {
        return
      }

      ticking = true
      requestAnimationFrame(() => {
        funcResize()
        oldWidth = window.innerWidth
        ticking = false
      })
    }
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize, { passive: true })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
  })

  return {
    handleResize
  }
}
